import styled from 'styled-components';

import Box, { BoxProps } from '../box';


const Root = styled.div`
	& .MuiDrawer-modal {
		position: static !important;
	}
`;

const Content = styled(Box)<BoxProps>`
	position: relative;
	width: 100%;
	min-height: 70px;
	background-color: #fff;
	padding: 16px;
`;

const CloseButtonLayout = styled.div`
	position: absolute;
	top: 50%;
	right: 6px;
	transform: translateY(-50%);
`;

export {
	Root,
	Content,
	CloseButtonLayout,
};
